import React from 'react';
import { Box, Heading, Text } from '@indeed/ifl-components';
import { ProgressFraction } from '../ProgressFraction/ProgressFraction';

interface FormHeaderProps {
    step: number;
    total: number;
    title: string;
    helperText?: string;
    additionalElement?: React.ReactNode;
}

export const FormHeader: React.FunctionComponent<FormHeaderProps> = ({
    step,
    total,
    title,
    helperText,
    additionalElement,
}) => (
    <Box sx={{ marginBlockEnd: '24px' }}>
        <Box
            sx={{
                display: 'flex',
                gap: 2 /* = 8px */,
                alignItems: 'flex-start',
                marginBlockEnd: '8px',
            }}
        >
            <ProgressFraction current={step} total={total} />
            {additionalElement}
        </Box>
        <Heading level={3} sx={{ fontSize: '24px', lineHeight: '1.25' }}>
            {title}
        </Heading>
        {helperText && (
            <Text sx={{ fontSize: '14px', color: 'foreground.secondary' }}>{helperText}</Text>
        )}
    </Box>
);

export default FormHeader;
